/**
 * Identifica un error de Firebase por su forma, no por su clase.
 *
 * `e instanceof FirebaseError` parece lo correcto y falla en producción. El
 * paquete se construye en fragmentos —Firebase en el suyo, cada pantalla en el
 * suyo— y la clase que se importa en un fragmento no siempre es la misma
 * instancia que usó otro al lanzar el error. El resultado es un `instanceof`
 * que devuelve falso para errores de Firebase auténticos.
 *
 * Costó encontrarlo porque el síntoma engañaba: al escribir mal la contraseña,
 * la pantalla decía «algo interrumpió la página» en vez de «correo o contraseña
 * incorrectos». El error real era `auth/invalid-credential` y quedaba oculto
 * tras la rama de «esto no viene de Firebase».
 *
 * Comprobar la forma —un `code` de texto -- es estable frente al empaquetado,
 * frente a las versiones del SDK y frente a los límites de fragmento.
 */
export function codigoFirebase(e: unknown): string | null {
  if (typeof e !== "object" || e === null) return null;
  const codigo = (e as { code?: unknown }).code;
  return typeof codigo === "string" && codigo.includes("/") ? codigo : null;
}
